import { useRef } from 'react';
import { Icon } from '@livechat/design-system-react-components';
import {
  ChevronDown as ChevronDownIcon,
  ChevronUp as ChevronUpIcon,
} from '@livechat/design-system-icons';

import { useClickOutside } from 'hooks/use-click-outside';

import { topMenuContainerStyles } from './styles';

type Props = {
  title: React.ReactNode;
  isMenuVisible: boolean;
  onClickOutside: () => void;
  toggleMenu: () => void;
  children: React.ReactNode;
};

export const ExpandingMenu: React.FC<Props> = ({
  children,
  title,
  isMenuVisible,
  onClickOutside,
  toggleMenu,
}) => {
  const triggerRef = useRef<HTMLDivElement | null>(null);
  useClickOutside(triggerRef, onClickOutside);

  return (
    <>
      <div onClick={toggleMenu} css={topMenuContainerStyles(isMenuVisible)} ref={triggerRef}>
        <div>{title}</div>
        <Icon source={isMenuVisible ? ChevronUpIcon : ChevronDownIcon} />
      </div>
      {isMenuVisible && <div>{children}</div>}
    </>
  );
};
